class SelectOtherToggle {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.dropdown = self.elem.querySelector('[data-select-other-toggle-select]');
        self.other = self.elem.querySelector('[data-select-other-toggle-other]');
        self.input = self.elem.querySelector('[data-select-other-toggle-other-input]');
    }

    init() {
        let self = this;

        self.checkDropdownValue();

        self.dropdown.addEventListener('input', evt => {
            self.checkDropdownValue();
        });
    }

    checkDropdownValue() {
        let self = this;

        if(self.dropdown.value === 'Other') {
            self.show();
        } else {
            self.hide();
        }
    }

    show() {
        let self = this;

        self.other.classList.remove('d-none');
        self.input.required = true;
        self.dropdown.setAttribute('aria-expanded', true);
    }

    hide() {
        let self = this;

        self.other.classList.add('d-none');
        self.input.required = false;
        self.dropdown.setAttribute('aria-expanded', false);
    }
}

export default SelectOtherToggle;
